import React from 'react';
import { Layout } from '../components/sections/Layout';
import { ComingSoonSection } from '../components/sections/ComingSoonSection';
import { ContactSection } from '../components/sections/ContactSection';
import { FinalCTA } from '../components/sections/FinalCTA';
export function ProchainementPage() {
  return <Layout data-id="element-821">
      <ComingSoonSection data-id="element-822" />
      <ContactSection data-id="element-823" />
      <FinalCTA data-id="element-824" />
    </Layout>;
}